<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.editDocflow') }}</h1>
      <div class="form-container">
        <DocflowOutgoingForm @save="save"
                             :edit-mode="true"
                             :document-data="documentData">
        </DocflowOutgoingForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import {mapState} from 'vuex'
  import DashboardLayout from '@/components/DashboardLayout'
  import DocflowOutgoingForm from '@/components/DocflowOutgoingForm'

  export default {
    components: {
      DashboardLayout,
      DocflowOutgoingForm
    },
    methods: {
      save(documentForm) {
        this.$store.dispatch('Docflow/update', {
          ...documentForm,
          category: 'outgoing'
        }).then(document => {
          this.$router.push({
            name: 'docflowOutgoingDetail',
            params: {documentId: document.id}
          })
        })
      }
    },
    mounted() {
      this.$store.dispatch('Docflow/getRelations', {category: 'outgoing', documentId: this.$route.params.documentId})
    },
    computed: {
      ...mapState('Docflow', ['document']),
      documentData() {
        return this.document ? {
          ...this.document,
          term_date: this.document.term_date ? new Date(this.document.term_date) : null
        } : {}
      },
      breadcrumbs() {
        return [
          { name: 'docflow', path: 'docflow' },
          {
            name: 'docflowDetail',
            path: {
              name: 'docflowOutgoingDetail',
              params: {documentId: this.$route.params.documentId}
            }
          },
          { name: 'editDocflow' }
        ]
      }
    }
  }
</script>